import { SvgIcon, SvgIconProps } from '@mui/material';

const ShapesIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.41667 9.1665L10 1.6665L14.5833 9.1665H5.41667ZM14.5833 18.3332C13.5417 18.3332 12.6562 17.9686 11.9271 17.2394C11.1979 16.5103 10.8333 15.6248 10.8333 14.5832C10.8333 13.5415 11.1979 12.6561 11.9271 11.9269C12.6562 11.1978 13.5417 10.8332 14.5833 10.8332C15.625 10.8332 16.5104 11.1978 17.2396 11.9269C17.9687 12.6561 18.3333 13.5415 18.3333 14.5832C18.3333 15.6248 17.9687 16.5103 17.2396 17.2394C16.5104 17.9686 15.625 18.3332 14.5833 18.3332ZM2.5 17.9165V11.2498H9.16667V17.9165H2.5ZM14.5833 16.6665C15.1667 16.6665 15.6597 16.4651 16.0625 16.0623C16.4653 15.6596 16.6667 15.1665 16.6667 14.5832C16.6667 13.9998 16.4653 13.5068 16.0625 13.104C15.6597 12.7012 15.1667 12.4998 14.5833 12.4998C14 12.4998 13.5069 12.7012 13.1042 13.104C12.7014 13.5068 12.5 13.9998 12.5 14.5832C12.5 15.1665 12.7014 15.6596 13.1042 16.0623C13.5069 16.4651 14 16.6665 14.5833 16.6665ZM4.16667 16.2498H7.5V12.9165H4.16667V16.2498ZM8.375 7.49984H11.625L10 4.87484L8.375 7.49984Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};

export default ShapesIcon;
